import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/views/Dashboard';
import Invitations from '@/views/Invitations';
import InvitationsReportDate from '@/views/ReportInvitationsDate';
import ContratistaAccesoListado from '@/views/ContratistaAccesoListado';
import InvitationsReportProperty from '@/views/ReportInvitationsProperty';
import Todo from '@/views/Todo';
import NotFound from '@/views/NotFound';
import user from './modules/user';
import { isLoggedIn } from './guards';
import { dashLayout } from './layout';
import userGestor from './modules/user-gestor';
import accessLogs from './modules/access-logs';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      components: {
        default: Dashboard,
        ...dashLayout,
      },
      beforeEnter: isLoggedIn,
    },
    {
      path: '/invitations',
      name: 'Invitations',
      components: {
        default: Invitations,
        ...dashLayout,
      },
      beforeEnter: isLoggedIn,
    },
    {
      path: '/invitations-report-date',
      name: 'InvitationsReportDate',
      components: {
        default: InvitationsReportDate,
        ...dashLayout,
      },
      beforeEnter: isLoggedIn,
    },
    {
      path: '/contractors-access',
      name: 'ContratistaAccesoListado',
      components: {
        default: ContratistaAccesoListado,
        ...dashLayout,
      },
      beforeEnter: isLoggedIn,
    },
    {
      path: '/invitations-report-property',
      name: 'InvitationsReportProperty',
      components: {
        default: InvitationsReportProperty,
        ...dashLayout,
      },
      beforeEnter: isLoggedIn,
    },
    {
      path: '/to-do',
      name: 'Todo',
      components: {
        default: Todo,
        ...dashLayout,
      },
      beforeEnter: isLoggedIn,
    },
    ...user,
    ...userGestor,
    ...accessLogs,
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js